import { render, staticRenderFns } from "./LandingPage.html?vue&type=template&id=79c06c6c&scoped=true&"
import script from "./LandingPage.js?vue&type=script&lang=js&"
export * from "./LandingPage.js?vue&type=script&lang=js&"
import style0 from "./LandingPage.scss?vue&type=style&index=0&id=79c06c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c06c6c",
  null
  
)

export default component.exports